<template>
  <section class="section section__content --centered">
    <h1 class="title --main" v-reveal>{{ content.title }}</h1>
    <p v-if="content.description" class="description" v-reveal="{ delay: 200 }">
      {{ content.description }}
    </p>
    <NoteBlock v-if="content.bar.length" :content="content.bar[0]" v-reveal="{ delay: 250 }" />
  </section>
</template>

<script>
import { NoteBlock } from '@/components/blocks'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'NoteSection',
  mixins: [DefaultSectionProps],
  components: { NoteBlock },
}
</script>
